import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'envc-list-download-item',
  styleUrl: 'envc-list-download-item.scss',
  shadow: false,
  scoped: true
})
export class EnvcListDownloadItem {
  /**
   * The button label
   */
  @Prop() label: string;
  @Prop() tooltip: string;
  @Prop() additionalClasses: string;
  @Prop() dataLayerEntry: string;
  @Prop() targetAttribute: string;
  @Prop() relAttribute: string;
  @Prop() url: string;

  public getAttributeValue(attribute: string): string {
    if (!attribute) {
      return ''
    }

    return attribute?.split('=')[1]
      ?.replace(/"/g, '')
      ?.replace(/'/g, '')
  }

  render() {
    return (
      <li>
        <a
          href={this.url}
          rel={this.getAttributeValue(this.relAttribute)}
          title={this.tooltip}
          class={"link + " + this.additionalClasses}
          data-layer-entry={this.dataLayerEntry}
          target={this.getAttributeValue(this.targetAttribute)}
        >
          { this.label }
        </a>
      </li>
    );
  }
}
